

















import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import { RubricStoreKey } from "@/store/StoreInjectionKeys";
import { injectStrict } from "@/lib/utils";
import { useRoles } from '@/modules/ees/dataProviders/metadata';
import RubricLinkRenderer from './components/RubricLinkRenderer.vue';
import AgTable from '@/modules/ees/components/AgTable.vue';

export default defineComponent({
  components: {
    AgTable
  },
  setup(props) {
    const rubricStore = injectStrict(RubricStoreKey);
    const { roleByValue } = useRoles();

    const table = reactive({ 
      columnDefs: [
        {
          headerName: 'Name',
          flex: 1,
          type: ['nonSortable', 'nonFilterable'],
          cellRendererFramework: RubricLinkRenderer 
        },
        {
          field: 'targetStaff',
          width: 300,
          autoHeight: true,
          cellRenderer: (params) => {
            const roles: string[] = []
            for (const r of params.value) {
              roles.push(roleByValue(r).text)
            }
            
            return '<ul class="mt-3 list-unstyled">' + roles.map((r:string) => `<li class='lh-1 my-1'><span class='badge bg-primary me-1'>${r}</span></li>`).join('') + '</ul>'
          }
        },
        {
          field: 'activeVersionNumber',
          type: ['numberColumn'],
          width: 250,
          cellRenderer: (params) => {
            return params.value || 'None'
          }
        }
      ]
    });

    onMounted(async () => {
      await rubricStore.actions.loadRubrics();
    })

    return {
      rubricStore,
      roleByValue,
      table
    };
  }
});
